// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Rana Process Types
 * Auto-generated input/output schemas for every Rana process tag. Do not edit manually.
 *
 * The version of the OpenAPI document: generated
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface RanaFileWithIdTemplate
 */
export interface RanaFileWithIdTemplate {
  /**
   *
   */
  id: string;
  /**
   *
   */
  ref?: string;
  /**
   *
   */
  variableType?: RanaFileWithIdTemplateVariableTypeEnum;
}

/**
 * @export
 */
export const RanaFileWithIdTemplateVariableTypeEnum = {
  RanaPath: "rana_path",
} as const;
export type RanaFileWithIdTemplateVariableTypeEnum =
  (typeof RanaFileWithIdTemplateVariableTypeEnum)[keyof typeof RanaFileWithIdTemplateVariableTypeEnum];

/**
 * Check if a given object implements the RanaFileWithIdTemplate interface.
 */
export function instanceOfRanaFileWithIdTemplate(value: object): value is RanaFileWithIdTemplate {
  if (!("id" in value) || value["id"] === undefined) return false;
  return true;
}

export function RanaFileWithIdTemplateFromJSON(json: any): RanaFileWithIdTemplate {
  return RanaFileWithIdTemplateFromJSONTyped(json, false);
}

export function RanaFileWithIdTemplateFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): RanaFileWithIdTemplate {
  if (json == null) {
    return json;
  }
  return {
    id: json["id"],
    ref: json["ref"] == null ? undefined : json["ref"],
    variableType: json["variable_type"] == null ? undefined : json["variable_type"],
  };
}

export function RanaFileWithIdTemplateToJSON(json: any): RanaFileWithIdTemplate {
  return RanaFileWithIdTemplateToJSONTyped(json, false);
}

export function RanaFileWithIdTemplateToJSONTyped(
  value?: RanaFileWithIdTemplate | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    id: value["id"],
    ref: value["ref"],
    variable_type: value["variableType"],
  };
}
